export class ListApiCredentialsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apiCredentials",
            "baseName": "apiCredentials",
            "type": "Array<ApiCredentialsProperties>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListApiCredentialsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
